class ChassisTabs extends HTMLElement {
  constructor() {
    (super(),
      (this.buttons = this.querySelectorAll('.chassis-tabs__button')),
      (this.panels = this.querySelectorAll('.chassis-tabs__panel')),
      (this.specSheet = this.querySelector('.spec-sheet')),
      (this.datasheet = this.querySelector('.datasheet')),
      (this.gpuSupport = this.querySelector('.gpu-support')),
      (this.nvme = this.querySelector('.nvme')),
      (this.dynamicTabsData = this.parseDynamicTabs()),
      console.log('DEBUG - Dynamic Tabs Data:', this.dynamicTabsData),
      this.bindEvents(),
      this.renderDynamicTabs());
  }
  parseDynamicTabs() {
    const allMetafieldsAttr = this.getAttribute('data-all-metafields');
    if ((console.log('DEBUG - data-all-metafields:', allMetafieldsAttr), !allMetafieldsAttr))
      return (console.log('DEBUG - No metafields found'), {});
    let allMetafields;
    try {
      ((allMetafields = JSON.parse(allMetafieldsAttr)),
        console.log('DEBUG - Parsed all metafields:', allMetafields));
    } catch (error) {
      return (
        console.error('DEBUG - Error parsing metafields JSON:', error),
        console.log('DEBUG - Raw JSON string:', allMetafieldsAttr),
        {}
      );
    }
    const tabsData = {};
    return (
      Object.keys(allMetafields).forEach((metafieldKey) => {
        if (
          (console.log(`DEBUG - Checking metafield: ${metafieldKey}`),
          metafieldKey.endsWith('_tab') || /.*_tab_\d+$/.test(metafieldKey))
        ) {
          const content = allMetafields[metafieldKey];
          if (
            (console.log(`DEBUG - Found tab metafield: ${metafieldKey} with content:`, content),
            this.isValidMetafieldContent(content))
          ) {
            const tabName = this.generateTabName(metafieldKey),
              tabId = this.generateTabId(metafieldKey),
              orderNumber = this.extractOrderNumber(metafieldKey),
              parsedContent = typeof content === 'string' ? this.parseRichTextContent(content) : this.parseJSONAttribute(null, JSON.stringify(content));
            (console.log(`DEBUG - Parsed content for ${metafieldKey}:`, parsedContent),
              parsedContent &&
                parsedContent.length > 0 &&
                (tabsData[tabId] = {
                  name: tabName,
                  id: tabId,
                  metafieldKey,
                  content: parsedContent,
                  order: orderNumber,
                }));
          } else console.log(`DEBUG - Skipping invalid/empty metafield: ${metafieldKey}`);
        }
      }),
      console.log('DEBUG - Final dynamic tabs:', tabsData),
      tabsData
    );
  }
  extractOrderNumber(metafieldKey) {
    const match = metafieldKey.match(/_tab_(\d+)$/);
    return match ? parseInt(match[1], 10) : 999;
  }
  isValidMetafieldContent(content) {
    if ((console.log('DEBUG - Validating content:', content, 'Type:', typeof content), !content))
      return (console.log('DEBUG - Content is null/undefined'), !1);
    if (content === null) return (console.log('DEBUG - Content is null (deleted metafield)'), !1);
    if (typeof content == 'string' && content.trim() === '')
      return (console.log('DEBUG - Content is empty string'), !1);
    if (typeof content == 'object') {
      if (content.type === 'root' && content.children) {
        const hasRealContent = this.hasRealRichTextContent(content);
        return (console.log('DEBUG - Rich text has real content:', hasRealContent), hasRealContent);
      }
      const isValid = Object.keys(content).length > 0;
      return (console.log('DEBUG - Object is valid:', isValid), isValid);
    }
    return (console.log('DEBUG - Content is valid (other type)'), !0);
  }
  hasRealRichTextContent(richTextObj) {
    if (!richTextObj || !richTextObj.children || richTextObj.children.length === 0)
      return (console.log('DEBUG - No children in rich text object'), !1);
    for (const child of richTextObj.children) {
      if (
        (console.log('DEBUG - Checking child:', child),
        child.type === 'text' && child.value && child.value.trim() !== '')
      )
        return (console.log('DEBUG - Found valid text content:', child.value.trim()), !0);
      if (
        (child.type === 'paragraph' && child.children && this.hasRealRichTextContent(child)) ||
        (child.children && this.hasRealRichTextContent(child))
      )
        return !0;
    }
    return (console.log('DEBUG - No real content found in rich text'), !1);
  }
  generateTabName(metafieldKey) {
    return metafieldKey
      .replace(/_tab(_\d+)?$/, '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());
  }
  generateTabId(metafieldKey) {
    return metafieldKey.replace(/_tab(_\d+)?$/, '').replace(/_/g, '-');
  }
  parseJSONAttribute(attributeName, content = null) {
    const attributeValue = content || this.getAttribute(attributeName);
    if (
      (attributeName && console.log(`DEBUG - ${attributeName}:`, attributeValue), !attributeValue)
    )
      return (attributeName && console.log(`DEBUG - ${attributeName} is empty`), []);
    try {
      const jsonResult = JSON.parse(attributeValue);
      if (
        (console.log(`DEBUG - ${attributeName} parsed as JSON:`, jsonResult),
        jsonResult && jsonResult.type === 'root' && jsonResult.children)
      ) {
        console.log(`DEBUG - ${attributeName} is Shopify rich text, extracting...`);
        const extractedHTML = this.extractTextFromShopifyRichText(jsonResult);
        return (
          console.log(`DEBUG - ${attributeName} extracted HTML:`, extractedHTML),
          this.parseRichTextContent(extractedHTML)
        );
      }
      return (
        console.log(`DEBUG - ${attributeName} unknown JSON format, trying as rich text...`),
        this.parseRichTextContent(JSON.stringify(jsonResult))
      );
    } catch {
      console.log(`DEBUG - ${attributeName} parsing as rich text...`);
      const richTextResult = this.parseRichTextContent(attributeValue);
      return (
        console.log(`DEBUG - ${attributeName} parsed as rich text:`, richTextResult),
        richTextResult
      );
    }
  }
  extractTextFromShopifyRichText(jsonObj) {
    let html = '';
    console.log('HTML-DEBUG [extractText] Input jsonObj children count:', jsonObj.children?.length);
    console.log('HTML-DEBUG [extractText] Raw children:', JSON.stringify(jsonObj.children, null, 2));
    if (jsonObj.children && Array.isArray(jsonObj.children)) {
      for (const child of jsonObj.children)
        if (child.type === 'paragraph' && child.children) {
          console.log('HTML-DEBUG [extractText] Paragraph child.children:', JSON.stringify(child.children));
          let paragraphHTML = '';
          for (const grandchild of child.children)
            paragraphHTML += this.convertRichTextNode(grandchild);
          console.log('HTML-DEBUG [extractText] paragraphHTML result:', paragraphHTML);
          console.log('HTML-DEBUG [extractText] containsHTMLTags?', this.containsHTMLTags(paragraphHTML));
          this.containsHTMLTags(paragraphHTML)
            ? (html += paragraphHTML)
            : (html += '<p>' + paragraphHTML + '</p>');
        } else if (child.type === 'list' && child.children) {
          const listTag = child.listType === 'ordered' ? 'ol' : 'ul';
          html += `<${listTag}>`;
          for (const listItem of child.children)
            if (listItem.type === 'list-item' && listItem.children) {
              html += '<li>';
              for (const itemChild of listItem.children)
                html += this.convertRichTextNode(itemChild);
              html += '</li>';
            }
          html += `</${listTag}>`;
        }
    }
    console.log('HTML-DEBUG [extractText] FINAL output html:', html);
    return html.trim();
  }
  containsHTMLTags(str) {
    return /<(?:table|thead|tbody|tr|td|th|div|span|img|h[1-6]|br|hr|iframe|video|audio|source|figure|figcaption|section|article|aside|header|footer|nav|main|details|summary|dl|dt|dd|abbr|address|blockquote|cite|code|pre|sup|sub|mark|small|time|wbr|picture|canvas|svg|path|rect|circle|line|polyline|polygon|ellipse|g|defs|use|symbol|text|tspan)\b[^>]*>/i.test(
      str,
    );
  }
  convertRichTextNode(node) {
    if (node.type === 'text') {
      let text = node.value || '';
      console.log('HTML-DEBUG [convertNode] node.value raw:', JSON.stringify(node.value));
      console.log('HTML-DEBUG [convertNode] node.value charCodes (first 50):', [...(node.value || '').slice(0, 50)].map(c => c + '=' + c.charCodeAt(0)));
      console.log('HTML-DEBUG [convertNode] containsHTMLTags?', this.containsHTMLTags(text));
      if (this.containsHTMLTags(text)) return text;
      return (
        node.bold && (text = `<strong>${text}</strong>`),
        node.italic && (text = `<em>${text}</em>`),
        node.underline && (text = `<u>${text}</u>`),
        node.strikethrough && (text = `<s>${text}</s>`),
        text
      );
    } else if (node.type === 'link' && node.url) {
      let linkText = '';
      if (node.children)
        for (const child of node.children) linkText += this.convertRichTextNode(child);
      return `<a href="${node.url}" target="_blank">${linkText}</a>`;
    }
    return '';
  }
  extractUserHTMLBlocks(content) {
    const userHTMLBlocks = [];
    const topLevelTags = 'table|div|span|img|h[1-6]|br|hr|iframe|video|audio|source|figure|figcaption|section|article|aside|header|footer|nav|main|details|summary|dl|dt|dd|abbr|address|blockquote|cite|code|pre|sup|sub|mark|small|time|wbr|picture|canvas|svg';
    const voidTags = new Set(['img', 'br', 'hr', 'wbr', 'source']);
    const tagStartRegex = new RegExp(`<(${topLevelTags})\\b`, 'gi');
    let result = '';
    let lastIndex = 0;
    let match;
    while ((match = tagStartRegex.exec(content)) !== null) {
      const tagName = match[1].toLowerCase();
      const startPos = match.index;
      if (voidTags.has(tagName)) {
        const voidEnd = content.indexOf('>', startPos);
        if (voidEnd === -1) continue;
        const fullMatch = content.substring(startPos, voidEnd + 1);
        result += content.substring(lastIndex, startPos);
        const placeholder = `__USER_HTML_${userHTMLBlocks.length}__`;
        userHTMLBlocks.push(fullMatch);
        result += placeholder;
        lastIndex = voidEnd + 1;
        tagStartRegex.lastIndex = lastIndex;
        continue;
      }
      let endPos = -1;
      const openRegex = new RegExp(`<${tagName}\\b`, 'gi');
      const closeRegex = new RegExp(`</${tagName}>`, 'gi');
      const allPositions = [];
      openRegex.lastIndex = startPos;
      let m;
      while ((m = openRegex.exec(content)) !== null) {
        allPositions.push({ pos: m.index, type: 'open' });
      }
      closeRegex.lastIndex = startPos;
      while ((m = closeRegex.exec(content)) !== null) {
        allPositions.push({ pos: m.index, type: 'close', end: m.index + m[0].length });
      }
      allPositions.sort((a, b) => a.pos - b.pos);
      let depth = 0;
      for (const item of allPositions) {
        if (item.type === 'open') {
          depth++;
        } else {
          depth--;
          if (depth === 0) {
            endPos = item.end;
            break;
          }
        }
      }
      if (endPos === -1) continue;
      const fullMatch = content.substring(startPos, endPos);
      result += content.substring(lastIndex, startPos);
      const placeholder = `__USER_HTML_${userHTMLBlocks.length}__`;
      userHTMLBlocks.push(fullMatch);
      result += placeholder;
      lastIndex = endPos;
      tagStartRegex.lastIndex = lastIndex;
    }
    result += content.substring(lastIndex);
    return { content: result, blocks: userHTMLBlocks };
  }
  parseRichTextContent(content) {
    console.log('DEBUG - parseRichTextContent input:', content);
    const products = [];
    let hasHTMLTags =
        content.includes('<p>') ||
        content.includes('<strong>') ||
        content.includes('<em>') ||
        content.includes('<ul>') ||
        content.includes('<s>'),
      hasUserHTML = this.containsHTMLTags(content),
      originalHTMLContent = content;
    const userHTMLBlocks = [];
    if (hasHTMLTags || hasUserHTML) {
      const extracted = this.extractUserHTMLBlocks(content);
      content = extracted.content;
      userHTMLBlocks.push(...extracted.blocks);
      (content = content.replace(/<p>/g, '').replace(
        /<\/p>/g,
        `
`,
      )),
      (content = content.replace(/<strong>/g, '**').replace(/<\/strong>/g, '**')),
      (content = content.replace(/<em>/g, '*').replace(/<\/em>/g, '*')),
      (content = content.replace(/<s>/g, '~~').replace(/<\/s>/g, '~~')),
      (content = content
        .replace(
          /<ul>/g,
          `
`,
        )
        .replace(
          /<\/ul>/g,
          `
`,
        )),
      (content = content.replace(/<li>/g, '\u2022 ').replace(
        /<\/li>/g,
        `
`,
      )),
      (content = content.replace(
        /<br\s*\/?>/g,
        `
`,
      ));
      userHTMLBlocks.forEach((block, i) => {
        content = content.replace(`__USER_HTML_${i}__`, block);
      });
      console.log('DEBUG - Content after HTML cleanup:', content);
    }
    let lines = content
      .split(
        `
`,
      )
      .map((line) => line.trim())
      .filter((line) => line);
    (console.log('DEBUG - Lines after split:', lines),
      lines.length <= 1 &&
        (console.log('DEBUG - Processing continuous text...'),
        (content = content.replace(
          /(ROWS\s+[^\n]+)/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(TEXT\s+[^\n]+)/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(REMIX\s+[^\n]+)/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(HYBRID\s+[^\n]+)/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(---[^-]+---)/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(\/\/\/[^/]+\/\/\/)/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(~~~[^~]+~~~)/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(\[TEXT\])/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(\[RICH\])/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(\[ROWS\])/g,
          `
$1
`,
        )),
        (content = content.replace(
          /(\[TABLE\])/g,
          `
$1
`,
        )),
        (content = content.replace(
          /([A-Z0-9\s\-"]+)(Condition:)/g,
          `$1
$2`,
        )),
        (content = content.replace(
          /(Condition:|Brand:|Chassis Type:|Form Factor:|Dimensions:|Processors:|Processor Sockets:|Memory:|Maximum RAM Speed:|RAID Controllers:|PCIe Slots:|I\/O Slots:|Hard Drives:|Max Storage:|Power Supplies:|Remote Management:|Rack Support:|Cooling Options:|Security Features:|Power Supply:|Remote Management:|Rack Support:|Warranty:)/g,
          `
$1`,
        )),
        (content = content.replace(
          /([A-Z0-9\s\-"]+)(?=R250)/g,
          `$1
`,
        )),
        console.log('DEBUG - Content after processing:', content),
        (lines = content
          .split(
            `
`,
          )
          .map((line) => line.trim())
          .filter((line) => line)),
        console.log('DEBUG - Lines after split:', lines)));
    let currentProduct = null,
      currentSpecs = [];
    for (const line of lines)
      if (
        (console.log(`DEBUG - Processing line: "${line}"`),
        (line.startsWith('ROWS ') ||
          line.startsWith('TEXT ') ||
          line.startsWith('REMIX ') ||
          line.startsWith('HYBRID ') ||
          (line.startsWith('~~~') && line.endsWith('~~~')) ||
          (line.startsWith('---') && line.endsWith('---')) ||
          (line.startsWith('///') && line.endsWith('///')) ||
          line.startsWith('PRODUCT:') ||
          (line === line.toUpperCase() && !line.includes(':') && line.length > 3) ||
          line.match(/^R250\s+[\d\w\-\s"]+$/)) &&
          line !== '[TEXT]' &&
          line !== '[RICH]' &&
          line !== '[ROWS]' &&
          line !== '[TABLE]')
      ) {
        if (currentProduct)
          if (currentProduct.isRichText) {
            let content2;
            if (currentProduct.hasHTMLContent && currentProduct.originalHTML) {
              content2 = currentProduct.originalHTML;
              const titlePattern = new RegExp(
                `(TEXT\\s+${currentProduct.title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}|${currentProduct.title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
                'gi',
              );
              ((content2 = content2.replace(titlePattern, '').trim()),
                (content2 = content2.replace(/^<p>/, '').replace(/<\/p>$/, '')));
            } else content2 = currentProduct.content.join('');
            products.push({
              productTitle: currentProduct.title,
              isRichText: !0,
              richTextContent: content2,
              hasHTMLContent: currentProduct.hasHTMLContent,
            });
          } else
            currentProduct.isMixed
              ? (this.finalizeMixedSection(currentProduct, currentSpecs),
                products.push({
                  productTitle: currentProduct.title,
                  isMixed: !0,
                  mixedSections: currentProduct.mixedSections || [],
                }))
              : products.push({
                  productTitle: currentProduct.title,
                  specifications: [...currentSpecs],
                });
        const cleanedTitle = line
            .replace('PRODUCT:', '')
            .replace(/^ROWS\s+/, '')
            .replace(/^TEXT\s+/, '')
            .replace(/^REMIX\s+/, '')
            .replace(/^HYBRID\s+/, '')
            .replace(/^---\s*/, '')
            .replace(/\s*---$/, '')
            .replace(/^\/\/\/\s*/, '')
            .replace(/\s*\/\/\/$/, '')
            .replace(/^~~~\s*/, '')
            .replace(/\s*~~~$/, '')
            .trim(),
          isRichTextTab =
            line.startsWith('TEXT ') || (line.startsWith('///') && line.endsWith('///')),
          isMixedTab =
            line.startsWith('REMIX ') ||
            line.startsWith('HYBRID ') ||
            (line.startsWith('~~~') && line.endsWith('~~~')),
          isRowsTab = line.startsWith('ROWS ') || (line.startsWith('---') && line.endsWith('---'));
        ((currentProduct = {
          title: cleanedTitle,
          isRichText: isRichTextTab,
          isMixed: isMixedTab,
          content: isRichTextTab || isMixedTab ? [] : null,
          mixedSections: isMixedTab ? [] : null,
          hasHTMLContent: hasHTMLTags && isRichTextTab,
          originalHTML: hasHTMLTags && isRichTextTab ? originalHTMLContent : null,
        }),
          (currentSpecs = []),
          console.log(
            `DEBUG - Created product: "${cleanedTitle}", isMixed: ${isMixedTab}, isRichText: ${isRichTextTab}`,
          ));
      } else if (currentProduct) {
        if (currentProduct.isRichText) currentProduct.content.push(line);
        else if (currentProduct.isMixed)
          if (
            (console.log(`DEBUG - Processing mixed line: "${line}"`),
            line === '[ROWS]' || line === '[TABLE]')
          )
            (console.log('DEBUG - Switching to ROWS mode'),
              this.finalizeMixedSection(currentProduct, currentSpecs),
              (currentProduct.currentSectionType = 'rows'),
              (currentProduct.currentSpecs = []));
          else if (line === '[TEXT]' || line === '[RICH]')
            (console.log('DEBUG - Switching to TEXT mode'),
              this.finalizeMixedSection(currentProduct, currentSpecs),
              (currentProduct.currentSectionType = 'text'),
              (currentProduct.currentTextContent = []));
          else if (currentProduct.currentSectionType === 'rows' && line.includes(':')) {
            const [label, ...valueParts] = line.split(':');
            let value = valueParts.join(':').trim();
            (this.containsHTMLTags(value)
              ? null
              : value.includes(',') || value.includes('|')
              ? (value = value
                  .split(/[,|]/)
                  .map((v) => v.trim())
                  .filter((v) => v))
              : value.includes(' - ') &&
                (value = value
                  .split(' - ')
                  .map((v) => v.trim())
                  .filter((v) => v)),
              currentProduct.currentSpecs || (currentProduct.currentSpecs = []),
              currentProduct.currentSpecs.push({ label: label.trim(), value }));
          } else
            currentProduct.currentSectionType === 'text'
              ? (console.log(`DEBUG - Adding text line: "${line}"`),
                currentProduct.currentTextContent || (currentProduct.currentTextContent = []),
                currentProduct.currentTextContent.push(line))
              : (currentProduct.currentSectionType ||
                  ((currentProduct.currentSectionType = 'text'),
                  (currentProduct.currentTextContent = [])),
                currentProduct.currentTextContent || (currentProduct.currentTextContent = []),
                currentProduct.currentTextContent.push(line));
        else if (line.includes(':')) {
          const [label, ...valueParts] = line.split(':');
          let value = valueParts.join(':').trim();
          (this.containsHTMLTags(value)
            ? null
            : value.includes(',') || value.includes('|')
            ? (value = value
                .split(/[,|]/)
                .map((v) => v.trim())
                .filter((v) => v))
            : value.includes(' - ') &&
              (value = value
                .split(' - ')
                .map((v) => v.trim())
                .filter((v) => v)),
            currentSpecs.push({ label: label.trim(), value }));
        }
      }
    if (currentProduct)
      if (currentProduct.isRichText) {
        let content2;
        if (currentProduct.hasHTMLContent && currentProduct.originalHTML) {
          content2 = currentProduct.originalHTML;
          const titlePattern = new RegExp(
            `(TEXT\\s+${currentProduct.title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}|${currentProduct.title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
            'gi',
          );
          ((content2 = content2.replace(titlePattern, '').trim()),
            (content2 = content2.replace(/^<p>/, '').replace(/<\/p>$/, '')));
        } else content2 = currentProduct.content.join('');
        products.push({
          productTitle: currentProduct.title,
          isRichText: !0,
          richTextContent: content2,
          hasHTMLContent: currentProduct.hasHTMLContent,
        });
      } else
        currentProduct.isMixed
          ? (this.finalizeMixedSection(currentProduct, currentSpecs),
            products.push({
              productTitle: currentProduct.title,
              isMixed: !0,
              mixedSections: currentProduct.mixedSections || [],
            }))
          : products.push({
              productTitle: currentProduct.title,
              specifications: [...currentSpecs],
            });
    return (console.log('DEBUG - parseRichTextContent result:', products), products);
  }
  finalizeMixedSection(currentProduct, currentSpecs) {
    if (
      (currentProduct.mixedSections || (currentProduct.mixedSections = []),
      currentProduct.currentSectionType === 'rows')
    ) {
      const specsToUse = currentProduct.currentSpecs || currentSpecs || [];
      specsToUse.length > 0 &&
        (currentProduct.mixedSections.push({ type: 'rows', specifications: [...specsToUse] }),
        currentProduct.currentSpecs && (currentProduct.currentSpecs = []),
        currentSpecs && (currentSpecs.length = 0));
    } else
      currentProduct.currentSectionType === 'text' &&
        currentProduct.currentTextContent &&
        currentProduct.currentTextContent.length > 0 &&
        (currentProduct.mixedSections.push({
          type: 'text',
          content: currentProduct.currentTextContent.join(`
`),
        }),
        (currentProduct.currentTextContent = []));
  }
  bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.switchTab(button));
    });
  }
  switchTab(selectedButton) {
    const targetPanel = selectedButton.dataset.tab;
    (this.buttons.forEach((button) => {
      button.classList.toggle('active', button === selectedButton);
    }),
      this.panels.forEach((panel) => {
        panel.classList.toggle('active', panel.dataset.panel === targetPanel);
      }));
  }
  renderDynamicTabs() {
    const tabsList = this.querySelector('.chassis-tabs__list'),
      tabsContent = this.querySelector('.chassis-tabs__content'),
      sortedTabs = Object.values(this.dynamicTabsData).sort((a, b) =>
        a.order !== b.order ? a.order - b.order : a.name.localeCompare(b.name),
      );
    (console.log(
      'DEBUG - Sorted tabs:',
      sortedTabs.map((tab) => ({ name: tab.name, order: tab.order })),
    ),
      sortedTabs.forEach((tabData) => {
        if (tabData.content && tabData.content.length > 0) {
          const tabButton = document.createElement('button');
          ((tabButton.className = 'chassis-tabs__button'),
            tabButton.setAttribute('data-tab', tabData.id),
            (tabButton.textContent = tabData.name),
            tabsList.appendChild(tabButton));
          const tabPanel = document.createElement('div');
          ((tabPanel.className = 'chassis-tabs__panel'),
            tabPanel.setAttribute('data-panel', tabData.id));
          const contentContainer = document.createElement('div');
          ((contentContainer.className = tabData.id),
            tabPanel.appendChild(contentContainer),
            this.renderTabContent(contentContainer, tabData.content),
            tabsContent.appendChild(tabPanel));
        }
      }),
      (this.buttons = this.querySelectorAll('.chassis-tabs__button')),
      (this.panels = this.querySelectorAll('.chassis-tabs__panel')),
      this.bindEvents());
  }
  renderTabContent(container, data) {
    if ((console.log('DEBUG - renderTabContent called:', container, data), !container)) {
      console.log('DEBUG - No container found');
      return;
    }
    if (!data?.length) {
      console.log('DEBUG - No data or empty data:', data);
      return;
    }
    if (data.length === 1 && data[0].isMixed) {
      this.renderMixedContent(container, data[0].mixedSections);
      return;
    }
    if (data.length > 1) {
      const tabsContainer = document.createElement('div');
      tabsContainer.className = 'product-tabs';
      const tabsList = document.createElement('div');
      tabsList.className = 'product-tabs__list';
      const tabsContent = document.createElement('div');
      ((tabsContent.className = 'product-tabs__content'),
        data.forEach((product, index) => {
          const tabButton = document.createElement('button');
          ((tabButton.className = `product-tabs__button ${index === 0 ? 'active' : ''}`),
            (tabButton.textContent = product.productTitle),
            (tabButton.dataset.productIndex = index));
          const tabContent = document.createElement('div');
          ((tabContent.className = `product-tabs__panel ${index === 0 ? 'active' : ''}`),
            tabButton.addEventListener('click', () => {
              (tabsList
                .querySelectorAll('.product-tabs__button')
                .forEach((btn) => btn.classList.toggle('active', btn === tabButton)),
                tabsContent
                  .querySelectorAll('.product-tabs__panel')
                  .forEach((panel) => panel.classList.toggle('active', panel === tabContent)));
            }),
            product.isRichText
              ? this.renderRichTextContent(
                  tabContent,
                  product.richTextContent,
                  product.hasHTMLContent,
                )
              : product.isMixed
                ? this.renderMixedContent(tabContent, product.mixedSections)
                : this.renderProductTable(tabContent, product.specifications),
            tabsList.appendChild(tabButton),
            tabsContent.appendChild(tabContent));
        }),
        tabsContainer.appendChild(tabsList),
        tabsContainer.appendChild(tabsContent),
        container.appendChild(tabsContainer));
    } else if (data.length === 1) {
      const product = data[0];
      product.isRichText
        ? this.renderRichTextContent(container, product.richTextContent, product.hasHTMLContent)
        : product.isMixed
          ? this.renderMixedContent(container, product.mixedSections)
          : this.renderProductTable(container, product.specifications);
    }
  }
  renderProductTable(container, specifications) {
    specifications.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'spec-sheet__row';
      const label = document.createElement('div');
      ((label.className = 'spec-sheet__label'), (label.textContent = item.label));
      const value = document.createElement('div');
      ((value.className = 'spec-sheet__value'),
        Array.isArray(item.value)
          ? item.value.forEach((val) => {
              value.innerHTML += val + '<br>';
            })
          : this.containsHTMLTags(String(item.value)) ? (value.innerHTML = item.value) : (value.textContent = item.value),
        row.appendChild(label),
        row.appendChild(value),
        container.appendChild(row));
    });
  }
  renderRichTextContent(container, content, hasHTMLContent = !1) {
    const richTextDiv = document.createElement('div');
    if (
      ((richTextDiv.className = 'rich-text-content'),
      console.log('DEBUG - renderRichTextContent:', { content, hasHTMLContent }),
      hasHTMLContent ||
        content.includes('<p>') ||
        content.includes('<strong>') ||
        content.includes('<em>') ||
        content.includes('<ul>') ||
        content.includes('<s>'))
    )
      richTextDiv.innerHTML = content;
    else {
      let formattedContent = content
        .replace(/\n/g, '<br>')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/~~(.*?)~~/g, '<s>$1</s>')
        .replace(/^([^<\n]+:)$/gm, '<strong>$1</strong>')
        .replace(/^[•\-]\s*(.+)$/gm, '<li>$1</li>')
        .replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>')
        .replace(/<\/ul>\s*<ul>/g, '')
        .replace(/^([^<][^:\n]*[^>])$/gm, '<p>$1</p>');
      richTextDiv.innerHTML = formattedContent;
    }
    container.appendChild(richTextDiv);
  }
  renderMixedContent(container, mixedSections) {
    if (
      (console.log('DEBUG - renderMixedContent called:', container, mixedSections),
      !mixedSections || mixedSections.length === 0)
    ) {
      console.log('DEBUG - No mixed sections to render');
      return;
    }
    mixedSections.forEach((section, index) => {
      if (
        (console.log(`DEBUG - Rendering section ${index}:`, section),
        section.type === 'rows' && section.specifications)
      )
        section.specifications.forEach((item) => {
          const row = document.createElement('div');
          row.className = 'spec-sheet__row';
          const label = document.createElement('div');
          ((label.className = 'spec-sheet__label'), (label.textContent = item.label));
          const value = document.createElement('div');
          ((value.className = 'spec-sheet__value'),
            Array.isArray(item.value)
              ? item.value.forEach((val) => {
                  value.innerHTML += val + '<br>';
                })
              : this.containsHTMLTags(String(item.value)) ? (value.innerHTML = item.value) : (value.textContent = item.value),
            row.appendChild(label),
            row.appendChild(value),
            container.appendChild(row));
        });
      else if (section.type === 'text' && section.content) {
        const textContainer = document.createElement('div');
        ((textContainer.style.marginBottom = '20px'),
          this.renderRichTextContent(textContainer, section.content, section.hasHTMLContent),
          container.appendChild(textContainer));
      }
    });
  }
}
customElements.define('chassis-tabs', ChassisTabs);
//# sourceMappingURL=/s/files/1/0718/8634/0351/t/27/assets/chassis-tabs.js.map?v=1763702642
